import React from 'react';
import FormControl from '@mui/material/FormControl';
import {
  Autocomplete,
  FormHelperText,
  FormLabel,
  TextField,
  createFilterOptions,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import InputCheckbox from './CheckBox';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Images from '../Utils/images';

interface Props {
  id: string;
  labelText?: string;
  placeHolderText?: string;
  clearIcon?: boolean;
  name?: string;
  error?: any;
  helperText?: any;
  defaultValue?: string | any;
  disabled?: boolean;
  value?: any;
  isCountryField?: boolean;
  onChange?: any;
  options: any;
  control?: null | any;
  setValue?: any;
  isError?: boolean;
  multiple?: boolean;
  isCheckbox?: boolean;
  requiredField?: boolean;
  limit?: number;
  disableClearable?: boolean;
  keyName?: string;
  errors?: any;
  height?: boolean;
  onChangeMethod?: any;
  size?: 'small' | 'medium';
}

export default function SelectPhoneNumber(props: Props) {
  const {
    id,
    labelText,
    placeHolderText,
    name = '',
    error,
    helperText,
    defaultValue,
    disabled,
    options,
    control,
    setValue,
    isCountryField = false,
    multiple,
    isCheckbox,
    requiredField,
    limit = 1,
    disableClearable = false,
    keyName = '',
    clearIcon,
    errors,
    height,
    onChangeMethod,
    size = 'medium',
  } = props;

 
  const [label, setLabel] = React.useState(false);
  const [open, setOpen] = React.useState(true);

  // Custom filter to search by both country name and dial code
  const filterOptions = createFilterOptions({
    stringify: (option: any) =>
      `${option.name} ${option.dial_code} ${option.code}`,
  });


  return (
    <FormControl
      fullWidth
      className={height ? 'customAutocomplete' : ''}
      error={error ? true : false}
    >
      <FormLabel
        className="formLabel"
        style={{ display: labelText ? 'block' : 'none' }}
      >
        {labelText} {requiredField ? <sup>*</sup> : null}{' '}
      </FormLabel>
      {/* {/ <InputLabel >{labelText}</InputLabel> /} */}
      {control ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue ?? '+1'}
          render={({ field }) => (
            <Autocomplete
              {...field}
              // open
              // disableCloseOnSelect={false}
              limitTags={limit}
              filterOptions={filterOptions} // Use custom filter
              disableClearable={true}
              popupIcon={<KeyboardArrowDownIcon />}
              disableCloseOnSelect={multiple ? true : false}
              disablePortal
              disabled={disabled}
              multiple={multiple ? true : false}
              id="combo-box-demo"
              size={size}
              placeholder={placeHolderText}
              getOptionLabel={option => `${option.flag} ${option.dial_code}`}
              isOptionEqualToValue={(option, value) =>
                option?.dial_code === value?.dial_code
              }
              //   defaultValue={defaultValue}

              renderOption={(props, option) => {
                return (
                  <li {...props}>
                    {' '}
                    {option?.flag} {option?.dial_code}
                  </li>
                );
              }}
              options={options}
              onChange={(event, newValue: any, reason) => {
            
                if (newValue?.isNew) {
                  setValue(name, { name: '' });
                } else {
                  setValue(name, newValue);
                }
                onChangeMethod && onChangeMethod(event);
              }}
              sx={{ width: '100%' }}
              renderInput={params => (
                <TextField
                  placeholder={placeHolderText}
                  {...params}
                  onChange={(event: any) => {
                    // Get the input value
                    const inputValue = event.target.value;

                    // Prevent entering more than 6 characters
                    if (inputValue.length > 6) {
                      event.target.value = inputValue.slice(0, 6); // Trim input
                    }

                    // Call the default onChange handler
                    params.inputProps.onChange?.(event);
                  }}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}
                  //   error={error ? true : false}
                  error={error ? true : false}

                  //   helperText={errors?.[name] && errors?.[name]?.message}
                />
              )}
              ChipProps={{
                deleteIcon: <img src={Images.CHIP_DELETE} alt="" />,
              }}
            />
          )}
        />
      ) : (
        <Autocomplete
          // open
          // disableCloseOnSelect={false}
          clearIcon
          disablePortal
          limitTags={limit}
          disableClearable={disableClearable}
          disableCloseOnSelect={multiple}
          id="combo-box-demo"
          size={size}
          options={options}
          placeholder={placeHolderText}
          multiple={multiple}
          sx={{ width: '100%' }}
          renderOption={
            isCheckbox
              ? (props, options, { selected }) => (
                  <li {...props}>
                    {isCheckbox ? (
                      <InputCheckbox
                        id={`check_${id}`}
                        name={`check_${name}`}
                        checked={selected}
                      />
                    ) : (
                      ''
                    )}
                    {options}
                  </li>
                )
              : undefined
          }
          renderInput={params => (
            <TextField
              placeholder={placeHolderText}
              {...params}
              error={error ? true : false}
            />
          )}
          ChipProps={{
            deleteIcon: <img src={Images.CHIP_DELETE} alt="" />,
          }}
        />
      )}

      <FormHelperText className={error ? 'Mui-error' : ''}>
        {error}
      </FormHelperText>
    </FormControl>
  );
}
